<template>
  <div class="login-container">
    <div class="login-content">
      <div class="login-box">
        <h2 class="login-title">登录工具箱</h2>

        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入用户名或账号号码"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-button" @click="submitForm('loginForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 底部备案号 -->
    <el-footer class="footer">
      <p>
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">豫ICP备2025112003号-1</a>
      </p>
    </el-footer>
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: '',
        password: '',

      },
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/login?' + qs.stringify(this.loginForm)).then(res => {
            console.log(res)
            const jwt = res.headers['authorization']
            this.$store.commit('SET_TOKEN', jwt)
            this.$router.push("/index")
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>

<style scoped>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden; /* 隐藏滚动条 */
}

.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden; /* 隐藏滚动条 */
}

.login-content {
  width: 100%;
  display: flex;
  justify-content: center; /* 登录框居中 */
  align-items: center;
}

.login-box {
  background-color: #ffffff; /* 白色登录框 */
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 380px;
  text-align: center;
}

.login-title {
  font-size: 24px;
  color: #303133;
  margin-bottom: 20px;
}

.login-button {
  width: 100%;
  margin-top: 10px;
}

.footer {
  background-color: #fafafa; /* 底部背景颜色 */
  padding: 25px; /* 减少 padding */
  border-top: 1px solid #e0e0e0;
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 12px; /* 调整字体大小 */
}

.footer p {
  margin: 0 auto;
  max-width: 380px;
  color: #666;
}

.footer a {
  color: inherit;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
}
</style>